import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
export const useIsServer = () => {
  const $ = _c(2);
  const [isServer, setIsServer] = useState(true);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsServer(false);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isServer;
};